import { snakeCase } from 'lodash';

import { DEFAULT_ERROR, useCustomSnackBar } from 'hooks/useCustomSnackBar';
import useUserHook from 'hooks/useUserHook';

import { useMutationSetHomePage } from 'api/mutations/setHomePage.mutation';
import { useQueryGetUserDetail } from 'api/queries/getUserDetail.query';

import { CustomizedTooltip } from 'components/common/CustomizedTooltip/CustomizedTooltip';
import Icon from 'components/common/Icons/base/Icon/Icon';

import { Button } from 'components/DesignSystem/Button';

import classes from './setHomePageContainer.module.scss';

interface Props {
    path: string;
    title: string;
}

export const SetHomePage = ({ path, title }: Props) => {
    const { email } = useUserHook();
    const { data: useData, refetch } = useQueryGetUserDetail({ email: email });
    const isCurrentHomePage = useData?.homePageUrl === path;

    const { handleSnackBar } = useCustomSnackBar();
    const mutation = useMutationSetHomePage();
    const handleClick = () => {
        if (!isCurrentHomePage) {
            mutation.mutate(
                { urlPage: path },
                {
                    onSuccess: () => {
                        refetch().then(() => handleSnackBar(`${title} was set as your home page`, 'success'));
                    },
                    onError: (error) => {
                        DEFAULT_ERROR({ error, handleError: handleSnackBar });
                    },
                },
            );
        }
    };

    return (
        <div className={classes.setHomePageContainer} onClick={handleClick}>
            {isCurrentHomePage ? (
                <CustomizedTooltip
                    triggerElement={
                        <Button id={`SetHomePage_${snakeCase(title)}`} variant={'tertiary'}>
                            <Icon name={'home-page-v'} color={'var(--button-tertiary-fg'} />
                        </Button>
                    }
                    tooltipContent={'Current Homepage'}
                />
            ) : (
                <CustomizedTooltip
                    triggerElement={
                        <Button id={`SetHomePage_${snakeCase(title)}`} variant={'tertiary'}>
                            <Icon name={'Critical-Analysis---Home'} color={'var(--button-tertiary-fg'} />
                        </Button>
                    }
                    tooltipContent={'Set as Homepage'}
                />
            )}
        </div>
    );
};
